(function () {
  'use strict';

  var exact = {
    'Kättesaamine poes': /\/cart\/?$/.test(window.location.pathname) ? 'Local delivery' : 'Kättesaamine poes',
    'Account': 'Konto',
    'Add': 'Lisa',
    'Share': 'Jaga',
    'Availability': 'Saadavus',
    'Category': 'Kategooria',
    'Color': 'Värv',
    'Featured': 'Esiletõstetud',
    'Most relevant': 'Kõige asjakohasemad',
    'Best selling': 'Enim müüdud',
    'Alphabetically, A-Z': 'Tähestikuliselt A–Z',
    'Alphabetically, Z-A': 'Tähestikuliselt Z–A',
    'Price, low to high': 'Hind: madalamast kõrgemani',
    'Price, high to low': 'Hind: kõrgemast madalamani',
    'Date, old to new': 'Kuupäev: vanemad enne',
    'Date, new to old': 'Kuupäev: uuemad enne',
    'Size': 'Suurus',
    'Shop All': 'Kõik tooted',
    'Bare Bliss Collection': 'Bare Bliss kollektsioon',
    'Apparel': 'Riided ja aksessuaarid',
    'Contact Us': 'Kontakt',
    'Size chart': 'Suurustabel',
    'Peachys Wear Swimwear Size Chart': 'Peachys Weari suurustabel',
    'Support': 'Klienditugi',
    'Our Story': 'Meie lugu',
    'Claim Your Peachys - SHOP ALL – Peachys Wear': 'Kõik bikiinid ja tooted – Peachys Wear',
    'Your Shopping Cart – Peachys Wear': 'Ostukorv – Peachys Wear',
    'Search – Peachys Wear': 'Otsing – Peachys Wear',
    'You may also like': 'Sulle võib meeldida ka',
    'Frequently bought together': 'Osta komplektina',
    'Use the Previous and Next buttons to navigate through product recommendations, or scroll horizontally to view more products.': 'Kasuta toodete sirvimiseks nuppe „Eelmine” ja „Järgmine” või libista horisontaalselt.',
    'Previous': 'Eelmine',
    'Next': 'Järgmine',
    'WELCOME BONUS': 'TERVITUSBOONUS',
    'Welcome bonus': 'Tervitusboonus',
    'Join free to see all benefits': 'Liitu tasuta ja vaata kõiki eeliseid',
    'Sign in or create account': 'Logi sisse või loo konto',
    'Sign in or create an account': 'Logi sisse või loo konto',
    'Home page': 'Avaleht',
    'Orders': 'Tellimused',
    'Profile': 'Profiil',
    'Loyalty Program': 'Boonusklubi',
    'Continue with Google': 'Jätka Google’iga',
    'OR': 'VÕI',
    'or': 'või',
    'Email': 'E-post',
    'Email me with news and offers': 'Soovin saada uudiseid ja pakkumisi e-postiga',
    'Sign in with Shop': 'Logi sisse Shopiga',
    'Sign in with': 'Logi sisse teenusega',
    'By continuing, Shop will share your email, name, and avatar with Peachys Wear. See their terms and privacy policy.': 'Jätkates jagab Shop sinu e-posti aadressi, nime ja profiilipilti Peachys Weariga. Vaata kasutustingimusi ja privaatsuspoliitikat.',
    'By continuing, Shop will share your email, name, and avatar with Peachys Wear. See their': 'Jätkates jagab Shop sinu e-posti aadressi, nime ja profiilipilti Peachys Weariga. Vaata nende',
    'terms': 'kasutustingimusi',
    'and': 'ja',
    'privacy policy': 'privaatsuspoliitikat',
    'Message us': 'Klienditugi',
    'Kirjuta meile': 'Klienditugi',
    'Cookie consent': 'Küpsiste nõusolek',
    'We and our partners, including Shopify, use cookies and other technologies to personalize your experience, show you ads, and perform analytics, and we will not use cookies or other technologies for these purposes unless you accept them.': 'Meie ja meie partnerid, sealhulgas Shopify, kasutame küpsiseid ja teisi tehnoloogiaid sinu kasutuskogemuse isikupärastamiseks, reklaamide näitamiseks ning analüütikaks. Nendel eesmärkidel kasutame neid ainult sinu nõusolekul.',
    'Learn more in our': 'Loe lähemalt meie',
    'Accept': 'Nõustu',
    'Decline': 'Keeldu',
    'Manage preferences': 'Halda eelistusi',
    'Privacy Policy': 'Privaatsuspoliitika',
    'Privacy policy': 'Privaatsuspoliitika',
    'Terms of service': 'Kasutustingimused',
    'Submit': 'Saada',
    'Tyla combines neutral tones, an adjustable top and a thong-cut bottom. The top has soft removable pads and a Peachys metal detail.': 'Tyla ühendab neutraalsed toonid, reguleeritava ülaosa ja string-lõikega alaosa. Ülaosal on pehmed eemaldatavad padjad ja Peachysi metalldetail.',
    'Sheila is a classic black set with an underwired, unpadded top and a high-cut thong bottom. Adjustable straps let you shape the fit to your body.': 'Sheila on klassikaline must komplekt toestava tugikaarega, polsterdamata ülaosa ja kõrge lõikega string-pükstega. Reguleeritavad õlapaelad aitavad istuvuse enda keha järgi paika sättida.',
    'Aria combines a blue and yellow wave print, an adjustable triangle top and a high-cut bottom with more coverage. Choose your top and bottom sizes separately.': 'Aria ühendab sinise-kollase lainemustri, reguleeritava kolmnurklõikega ülaosa ja kõrgema lõikega katvama alaosa. Üla- ja alaosa suuruse saad valida eraldi.',
    'Luxury Swimwear vs. Cheap Swimwear: You Really Do Get What You Pay For': 'Kvaliteetsed vs. odavad bikiinid: miks hinnavahe päriselt loeb',
    'Luxury Swimwear vs. Cheap Swimwear: You Really ...': 'Kvaliteetsed vs. odavad bikiinid: miks hinnavahe loeb',
    'In a world filled with fast fashion and ultra-cheap swimwear, it’s easy to overlook the true cost of quality. But when it comes to swimwear, what you pay for truly...': 'Kiirmoe ja üliodavate bikiinide maailmas on lihtne kvaliteedi tegelikku väärtust alahinnata. Ujumisriiete puhul mõjutab hind aga päriselt materjali, istuvust ja vastupidavust…',
    'Our limited Ballzy × Peachys Wear collab blends sneakers and swimwear into the ultimate summer vibe. See the film, campaign shots, and exclusive collection details!': 'Ballzy × Peachys Weari limiteeritud koostöö ühendab ketsid ja ujumisriided üheks suviseks tervikuks. Vaata kampaaniafilmi, fotosid ja kollektsiooni detaile!',
    'Bare Bliss – BTS': 'Bare Bliss – kaadri taga',
    'About Us': 'Meist',
    'We are back!': 'Oleme tagasi!',
    'We’re finally giving you a sneak peek into Bare Bliss — our brand new swimwear collection made for golden days, wild nights, and unapologetic confidence. We got the girls together, turned...': 'Piilu Bare Blissi kaadri taha — see ujumisriiete kollektsioon sündis kuldsete päevade, pööraste õhtute ja kompromissitu enesekindluse jaoks…'
  };

  // Product names always come from Shopify; do not translate them here.
  var embeddedReplacements = [
    ['Shop All', 'Kõik tooted']
  ];

  function translate(value) {
    if (!value || typeof value !== 'string') return value;
    var trimmed = value.trim();
    var result = exact[trimmed];

    if (!result) {
      result = trimmed
        .replace(/^Earn (\d+) points with this purchase$/, 'Selle ostuga teenid $1 punkti')
        .replace(/^Earn (\d+) points$/, 'Teeni $1 punkti')
        .replace(/^Select variant for (.+)$/, 'Vali suurus tootele $1');
    }

    if (!result || result === trimmed) {
      result = trimmed;
      embeddedReplacements.forEach(function (pair) {
        result = result.split(pair[0]).join(pair[1]);
      });
    }

    return result === trimmed ? value : value.replace(trimmed, result);
  }

  function translateElement(element) {
    if (!element || element.nodeType !== 1) return;
    ['aria-label', 'alt', 'placeholder', 'title'].forEach(function (attribute) {
      if (!element.hasAttribute(attribute)) return;
      var current = element.getAttribute(attribute);
      var translated = translate(current);
      if (translated !== current) element.setAttribute(attribute, translated);
    });
  }

  function translateRoot(root) {
    if (!root) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      if (node.parentElement && /^(SCRIPT|STYLE|NOSCRIPT|TEXTAREA)$/.test(node.parentElement.tagName)) continue;
      var translated = translate(node.nodeValue);
      if (translated !== node.nodeValue) node.nodeValue = translated;
    }

    if (root.nodeType === 1) translateElement(root);
    root.querySelectorAll?.('*').forEach(function (element) {
      translateElement(element);
      if (element.shadowRoot) observeRoot(element.shadowRoot);
    });

    root.querySelectorAll?.('.essential-upsell-frequently-bought-together-block img[alt=""]').forEach(function (image) {
      var productRoot = image.closest('[data-essential-upsell-element="product"]');
      var productTitle = productRoot?.querySelector('[data-essential-upsell-element="title"]')?.textContent?.trim();
      if (productTitle) image.alt = productTitle + ' tootepilt';
    });
  }

  var observedRoots = new WeakSet();

  function styleSupportButton(root) {
    if (!root || root.host?.tagName !== 'SHOPIFY-CHAT') return;

    var style = root.getElementById('peachys-support-button-style');
    if (!style) {
      style = document.createElement('style');
      style.id = 'peachys-support-button-style';
      style.textContent = [
        '.activator-nudge {',
        '  right: 30px !important;',
        '  bottom: 30px !important;',
        '  width: 156px !important;',
        '  height: 46px !important;',
        '}',
        '.activator {',
        '  box-sizing: border-box !important;',
        '  width: 156px !important;',
        '  min-width: 156px !important;',
        '  height: 46px !important;',
        '  min-height: 46px !important;',
        '  padding: 0 16px !important;',
        '  border-radius: 23px !important;',
        '  background: rgba(17, 17, 17, 0.94) !important;',
        '  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.16) !important;',
        '  font-family: var(--font-body-family, sans-serif) !important;',
        '  font-size: 13px !important;',
        '  font-weight: 700 !important;',
        '  line-height: 1 !important;',
        '  letter-spacing: 0.02em !important;',
        '  justify-content: center !important;',
        '  scale: 1 !important;',
        '}',
        '.activator__label { font: inherit !important; white-space: nowrap !important; }',
        '.activator__icon { width: 18px !important; height: 18px !important; }',
        '@media (max-width: 749px) {',
        '  .activator-nudge { right: 16px !important; bottom: 16px !important; width: 150px !important; height: 46px !important; }',
        '  .activator { width: 150px !important; min-width: 150px !important; }',
        '}'
      ].join('\n');
      root.appendChild(style);
    }
  }

  function observeRoot(root) {
    if (!root) return;
    styleSupportButton(root);
    if (observedRoots.has(root)) {
      translateRoot(root);
      return;
    }
    observedRoots.add(root);
    translateRoot(root);

    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'characterData') {
          var changed = translate(mutation.target.nodeValue);
          if (changed !== mutation.target.nodeValue) mutation.target.nodeValue = changed;
          return;
        }
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) translateRoot(node);
          if (node.nodeType === 3) {
            var translated = translate(node.nodeValue);
            if (translated !== node.nodeValue) node.nodeValue = translated;
          }
        });
      });
    }).observe(root, { childList: true, characterData: true, subtree: true });
  }

  function init() {
    observeRoot(document);
    var translatedTitle = translate(document.title);
    if (translatedTitle !== document.title) document.title = translatedTitle;
    [500, 2000, 5000].forEach(function (delay) {
      window.setTimeout(function () { translateRoot(document); }, delay);
    });
  }

  window.PeachysUiEt = { init: init };
})();
